/* 文章搜索结果高亮：只修改可见文字节点，不改原文数据、链接或搜索排序。 */
(() => {
  if (customElements.get('ggjia-search-highlights')) return;
  class GGJIASearchHighlights extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.start = () => {
        this.root = document.querySelector('#MainContent') || document.querySelector('main');
        if (!this.root) return;
        this.observer = new MutationObserver(() => this.refresh());
        this.refresh();
      };
      const signal = this.controller.signal;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true, signal });
      else this.start();
      window.addEventListener('popstate', () => this.refresh(), { signal });
      document.addEventListener('shopify:section:load', () => this.refresh(), { signal });
    }
    refresh() {
      if (!this.root || !this.observer) return;
      // 暂停观察自己的标记操作，避免形成无限更新循环。
      this.observer.disconnect();
      try {
        const params = new URLSearchParams(location.search);
        const query = params.get('q') ?? this.dataset.query ?? '';
        if (this.lastQuery !== query) {
          this.root.querySelectorAll('mark.ga-search-match').forEach(mark => {
            const parent = mark.parentNode;
            mark.replaceWith(document.createTextNode(mark.textContent));
            parent.normalize();
          });
          this.lastQuery = query;
        }
        // 按关键词逐项匹配、不区分大小写；转义正则字符，用户输入不作为 HTML 执行。
        const terms = [...new Set(query.trim().split(/\s+/).filter(Boolean))]
          .sort((a, b) => b.length - a.length)
          .map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
        if (!terms.length) return;
        const pattern = new RegExp(terms.join('|'), 'giu');
        // 同时兼容旧 Ella 结果和新的文章专用模板；不处理侧栏近期文章。
        this.root.querySelectorAll('#CollectionProductGrid [data-listed-article-or-page], .ga-search-page [data-ga-search-result]').forEach(card => {
          const link = card.querySelector('.title a[href], .gas-card-title a[href]');
          if (!link || !new URL(link.href, location.origin).pathname.includes('/blogs/')) return;
          card.querySelectorAll('.title, .summary, .gas-card-title, .gas-card-summary').forEach(container => {
            const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
              acceptNode: node => node.parentElement.closest('mark, script, style, textarea, button, [hidden]')
                ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
            });
            const nodes = [];
            while (walker.nextNode()) nodes.push(walker.currentNode);
            nodes.forEach(node => {
              pattern.lastIndex = 0;
              const matches = [...node.data.matchAll(pattern)];
              if (!matches.length) return;
              const fragment = document.createDocumentFragment();
              let offset = 0;
              matches.forEach(match => {
                fragment.append(document.createTextNode(node.data.slice(offset, match.index)));
                const mark = document.createElement('mark');
                mark.className = 'ga-search-match';
                mark.textContent = match[0];
                fragment.append(mark);
                offset = match.index + match[0].length;
              });
              fragment.append(document.createTextNode(node.data.slice(offset)));
              node.replaceWith(fragment);
            });
          });
        });
      } finally {
        // 兼容当前搜索模板通过 AJAX 替换结果和分页内容。
        this.observer.observe(this.root, { subtree: true, childList: true, characterData: true });
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  }
  customElements.define('ggjia-search-highlights', GGJIASearchHighlights);
})();
